<template lang="pug">
  autocomplete(
  root-class="simple-autocomplete",
  input-class="simple-input",
  :input-attrs="{id: 'search'}"
  :value="simpleSearch"
  :placeholder="placeholder",
  :items="internalItems",
  group-options,
  :focus-on-create="true",
  :get-label="getLabel",
  :get-value="getValue",
  :min-len="0",
  :keep-open="false",
  :no-matches-text="noMatchesText"
  @focus="focus",
  @change="autocompleteDebounce",
  @enter="enter",
  @item-selected="itemSelected")
    template(slot-scope="{ item }")
      .autocomplete-item
        a.title(v-html="getLabel(item)")
        //.id-block(v-if="item.id")
          p.id {{item.id}}
          font-awesome-icon.icon(icon="external-link-alt")
</template>
<script>
import Autocomplete from '../lei-components/inputs/Autocomplete'
import { mapMutations, mapState, mapActions, } from 'vuex'
import {
  CHANGE_SIMPLE_SEARCH,
} from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import debounce from 'lodash/debounce'

export default {
  components: {
    Autocomplete,
  },
  mixins: [ routerSearch, ],
  props: {
    placeholder: {
      type: String,
      default: 'Search for LEI, legal name or other data fields',
    },
  },
  data () {
    return {
      auto: [],
      fuzzy: [],
    }
  },
  computed: {
    internalItems () {
      return [
        { items: this.auto, },
        {
          title: this.auto.length === 0
            ? 'No suggestions available. Did you mean...'
            : 'Or did you mean...',
          items: this.fuzzy,
        },
      ].filter(({ items, }) => items.length !== 0)
    },
    noMatchesText () {
      return this.simpleSearch ? 'No matched items...' : 'Please start typing to see suggestions.'
    },

    ...mapState('search', [ 'fulltextFilter', 'simpleSearch', ]),
  },
  methods: {
    getLabel: (item) => item ? item.highlighting || item.value || item : '',
    getValue: (item) => item ? item.value || item : '',
    parseData (data) {
      return data
        .slice(0, 5)
        .map(({ attributes: { value, highlighting, }, type, relationships, }) => (
          {
            value,
            highlighting,
            type,
            id: relationships ? relationships['lei-records'].data.id : null,
          }
        ))
    },
    focus (val) {
      if (val) this.autocompleteDebounce(val)
    },
    autocompleteQuery (endpoint = 'autocompletions', val, arr) {
      if (this.fulltextFilter.field) {
        return this.autocomplete({
          endpoint,
          q: val,
          field: this.fulltextFilter.field,
        })
          .then((data) => {
            this[arr] = this.parseData(data)
          })
      }
    },
    autocompleteDebounce: debounce(function (val) {
      this.changeSimpleSearch(val || '')
      if (val.trim().length > 0) Promise.all([ this.autocompleteQuery('fuzzycompletions', val, 'fuzzy'), this.autocompleteQuery('autocompletions', val, 'auto'), ]).catch((e) => console.error(Error(e)))
    }, 500),
    enter (item) {
      this.changeSimpleSearch(item)
      this.routerSearch()
    },
    itemSelected ({ value, id, }) {
      this.changeSimpleSearch(value)
      id ? this.$router.push({
        name: 'RecordDetailsPage',
        params: { id, },
      }) : this.routerSearch()
    },

    ...mapActions('search', [ 'autocomplete', ]),
    ...mapMutations('search', {
      changeSimpleSearch: CHANGE_SIMPLE_SEARCH,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  $input-height = $input-md
  $input-height-mobile = $input-md

  .simple-autocomplete
    z-index 1
    flex-grow 1
    position relative

    b
      color $default-color-bold
      font-weight 900

    .simple-input
      height $input-height
      width 100%
      margin 1px
      border 0
      color $default-color-bold
      font-size 1rem
      padding 17.5px 20px

      &::placeholder
        color $default-color-light-1
        font-weight 600

    .autocomplete-input-group
      width 100%
      border-left 1px solid $cyprus-color

    .autocomplete-list
      height fit-content
      border 1px solid $default-color-light-2
      background-color $white-color
      position absolute
      bottom 0
      transform translateY(100%)
      text-align left
      width 100%
      box-shadow $box-shadow-light
      /*max-height 238px*/
      overflow-y auto

      .autocomplete-list-group-title
        background-color $default-color-light-2
        font-weight 600

      .autocomplete-list-item
        font-weight 600

        &:hover, &.autocomplete-item-active
          background-color $primary-color-light-3

      .autocomplete-list-item, .autocomplete-list-group-title
        cursor pointer
        display flex
        align-items center
        padding 10px 12px
        color $default-color-bold
        font-size .75rem

        .autocomplete-item
          white-space pre
          width 100%
          display flex
          align-items center
          justify-content space-between
          .id-block
            display flex
            align-items center
            font-weight 400
            color $default-color-middle-1
            .id
              font-size 90%
            .icon
              margin-left 5px

  @media (max-width: $tablet)
    .simple-autocomplete
      margin 15px 0

      .simple-input
        height $input-height-mobile

  @media (max-width: $mobile)
    .simple-autocomplete
      .autocomplete-list
        .autocomplete-list-item, .autocomplete-list-group-title
          .autocomplete-item
            .id-block
              .id
                display none
</style>



// WEBPACK FOOTER //
// src/components/search-components/SimpleInput.vue